// composables/useAppToast.ts
import { useToast, POSITION, TYPE } from "vue-toastification";

export function useAppToast() {
  const toast = useToast();

  const showToast = (
    message: string,
    type: "success" | "error" | "info" | "warning" = "info"
  ) => {
    toast(message, {
      type: type as TYPE,
      position: POSITION.TOP_RIGHT,
      timeout: 3000,
      closeOnClick: false,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.6,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      closeButton: "button",
      icon: true,
      rtl: false,
    });
  };

  return { showToast };
}
